import InfiniteScroll from 'infinite-scroll';
export default {
    init() {
        console.log('case studies');
        var elem = document.querySelector('.col-content');
        // eslint-disable-next-line no-unused-vars
        var infScroll = new InfiniteScroll( elem, {
            // options
            path: '.next',
            append: '.case-study',
            status: '.page-load-status',
            history: false,
            button: '.view-more',
// load pages on button click
            scrollThreshold: false,
// disable loading on scroll
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/case-studies.js